import * as React from "react";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box } from "@mui/material";
import { useState, useEffect } from "react";
import BAVAdminButton from "./BAVAdminButton";
function BAVButtonColumn(props) {
    const { handleAuswertung, handleEdit, setEntryActive, active, hasAdmin, handleShow, profileActive, rowData, showSnackbarFunc, handleStandingOrder, disableAuswertung} =
        props;
    const [disabled, setDisabled] = useState(active == 1 ? true : false);
    const [_active, setActive] = useState(active == 1 ? true : false);
    const [showDlgChanged, setShowDlgChanged] = useState(false);
    const [changeConfirmed, setChangeConfirmed] = useState(false);

    function handleActive(e) {
        if (profileActive && !_active && !changeConfirmed) {
            setShowDlgChanged(true);
            return;
        }
          setDisabled((oldvalue) => !oldvalue);
          var newval = !_active;
          setActive(newval);
          setEntryActive(e);
    }
    function handleReconfirm(e) {
        const levnt = {
            target: {
                checked: true
            }
        }
        setActive(true);
        setEntryActive(levnt);
        if (profileActive && !_active && !changeConfirmed) {
            setShowDlgChanged(false);
            setChangeConfirmed(true);
        }
    }
    function handleCloseDlg() {
        setShowDlgChanged(false);
    }
    return (
        <>
            <Button
                className="m-1 bav"
                onClick={handleAuswertung}
                variant="contained"
                style={{
                    maxWidth: "75px",
                    maxHeight: "20px",
                    minWidth: "75px",
                    minHeight: "20px",
                    fontSize: "0.65rem"
                }}
                disabled={disableAuswertung}
            >
                Auswertung
            </Button>
            <Button
                className="m-1 bav"
                onClick={handleShow}
                variant="contained"
                style={{
                    maxWidth: "55px",
                    maxHeight: "20px",
                    minWidth: "5px",
                    minHeight: "20px",
                    fontSize: "0.65rem"
                }}
            >
                Ansicht
            </Button>
            <Button
                className="m-1 bav"
                onClick={handleEdit}
                variant="contained"
                style={{
                    maxWidth: "70px",
                    maxHeight: "20px",
                    minWidth: "70px",
                    minHeight: "20px",
                    fontSize: "0.65rem"
                }}
                disabled={disabled}
            >
                Bearbeiten
            </Button>
            {(rowData.entryType != "1" && rowData.entryType != "4" && Number(rowData.editKtGnr.slice(-2)) < 70 &&               
                <Button
                    className="m-1 bav-da"
                    onClick={handleStandingOrder}
                    variant="contained"
                    style={{
                        maxWidth: "85px",
                        maxHeight: "20px",
                        minWidth: "85px",
                        minHeight: "20px",
                        fontSize: "0.65rem"
                    }}
                    disabled={false}
                >
                    Dauerauftrag
                </Button>
                )
            }
            {(rowData.entryType == "4" && Number(rowData.editKtGnr.slice(-2)) < 70 &&
                <Box style={{ maxWidth: "85px", minWidth: "85px", margin: "2px" }}
                    ></Box>
            )
            }
            {(rowData.editKtGnr && Number(rowData.editKtGnr.slice(-2)) >= 70 &&
                <Box style={{ maxWidth: "85px", minWidth: "85px", margin: "2px" }}
                ></Box>
            )
            }
            {hasAdmin ? (
                /*
                <Button
                    className="m-1 bav"
                    onClick={handleDelete}
                    variant="contained"
                    style={{
                        maxWidth: "70px",
                        maxHeight: "20px",
                        minWidth: "60px",
                        minHeight: "20px",
                        fontSize: "0.75rem"
                    }}
                    disabled={disabled}
                >
                    Löschen
                </Button>
                */
                <BAVAdminButton
                    rowData={rowData}
                    showSnackbarFunc={showSnackbarFunc}
                />
            ) : <div style={{
                    maxWidth: "50px",
                    maxHeight: "20px",
                    minWidth: "50px",
                    minHeight: "20px",
                    fontSize: "0.65rem"
                }}></div>  }
            <Checkbox onChange={handleActive} checked={_active}></Checkbox>
            <Dialog
                open={showDlgChanged}
                onClose={handleCloseDlg}
                aria-labelledby="alert-dialog-title-changed"
                aria-describedby="alert-dialog-description-changed"
            >
                <DialogTitle id="alert-dialog-title-changed">
                    {"Anlageprofil bestätigen"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description-changed">
                        Bitte stellen Sie sicher, dass nach der Aktivierung die Profilierung vom Kunden unterschrieben wird und dass in Finnova eine Notiz dazu erfasst wird.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" className="m-1 bav" onClick={handleCloseDlg}>Abbrechen</Button>
                    <Button variant="contained" className="m-1 bav" onClick={handleReconfirm} autoFocus>
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
            
        </>
    );
}
export default BAVButtonColumn;
